import toast from 'react-hot-toast';
import api from '../Crypto/axios.js';
import axios from "axios";


export const FETCH_ALL_BUYER = 'FETCH_ALL_BUYER';
export const ADD_NEW_BUYER = 'ADD_NEW_BUYER';
export const SET_SELECTED_BUYER = 'SET_SELECTED_BUYER';
export const CLEAR_DATA = 'CLEAR_DATA';
const BASE_URL = process.env.REACT_APP_API_URL;

const initialState = {
  allBuyer: [],
  newBuyer: [],
  selectedBuyer: {},
};

const BuyerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_BUYER:
      return {
        ...state,
        allBuyer: action.payload,
      };
    case ADD_NEW_BUYER:
      return {
        ...state,
        newBuyer: action.payload,
      };
    case SET_SELECTED_BUYER:
      return {
        ...state,
        selectedBuyer: action.payload,
      };
    case CLEAR_DATA:
      return {
        ...state,
        selectedBuyer: {},
        error: null,
      };
    default:
      return state;
  }
};

export default BuyerReducer;

export const fetchAllBuyer = (data) => ({
  type: FETCH_ALL_BUYER,
  payload: data,
});
export const addBuyer = (data) => ({
  type: ADD_NEW_BUYER,
  payload: data,
});
export const clearData = () => ({
  type: CLEAR_DATA,
});
export const setSelectedBuyer = (data) => ({
  type: SET_SELECTED_BUYER,
  payload: data,
});

// export const getAllBuyer = (id) => {
//   return async (dispatch) => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/nrcb/ecom/get/buyer/${id}`,
//         {
//           method: 'GET',
//         }
//       );
//       if (!response.ok) {
//         if (response.status === 404) {
//           dispatch(clearData());
//         } else {
//           throw new Error('Failed to get buyer');
//         }
//       }
//       const val = await response.json();
//       dispatch(fetchAllBuyer(val));
//     } catch (error) {
//       console.error('Failed to fetch buyer:', error);
//     }
//   };
// };
export const getAllBuyer = (id) => {
  return async (dispatch) => {
    const promise = api
      .get(`/nrcb/ecom/get/buyer/${id}`, { requiresAuth: true })
      .then((response) => {
        dispatch(fetchAllBuyer(response));
        return response;
      });
    return promise.catch(() => {
      return { status: 'error', message: 'Failed to fetch buyers' };
    });
  };
};

// export const addNewBuyer = (newBuyer) => {
//   return async (dispatch) => {
//     const promise = (async () => {
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}/nrcb/ecom/new/buyer`,
//           {
//             method: 'POST',
//             body: JSON.stringify(newBuyer),
//             headers: { 'Content-Type': 'application/json' },
//           }
//         );
//         if (!response.ok) {
//           const errorData = await response.json();
//           const errorMessage = errorData.message || 'Failed to add buyer';
//           throw new Error(errorMessage);
//         }
//         const val = await response.json();
//         dispatch(addBuyer(val));
//         return val;
//       } catch (error) {
//         console.error('Error in add new buyer:', error);
//         throw error;
//       }
//     })();

//     toast.promise(promise, {
//       loading: 'Adding New Buyer...',
//       success: 'New Buyer Added',
//       error: (error) => {
//         return error.message || 'Failed to add Buyer';
//       },
//     });
//     return promise;
//   };
// };

// export const getBuyerById = (buyerId) => {
//   return async (dispatch) => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/nrcb/ecom/get/onebuyer/${buyerId}`,
//         {
//           method: 'GET',
//         }
//       );
//       if (!response.ok) {
//         if (response.status === 404) {
//           dispatch(clearData());
//         } else {
//           throw new Error('Failed to get buyer');
//         }
//       }
//       const val = await response.json();

//       dispatch(setSelectedBuyer(val));
//       return val;
//     } catch (error) {
//       console.error('Failed to fetch buyer:', error);
//     }
//   };
// };

export const addNewBuyer = (newBuyer) => {
  return async (dispatch) => {
    const promise = api
      .post('/nrcb/ecom/new/buyer', newBuyer, { requiresAuth: true })
      .then((response) => {
        dispatch(addBuyer(response));
        return response;
      })
      .catch((error) => {
        // Handle 409 specifically
        if (error.response?.status === 409) {
          return Promise.reject(new Error('Email ID already exists'));
        }
        return Promise.reject(error);
      });

    toast.promise(promise, {
      loading: 'Adding New Buyer...',
      success: 'New Buyer Added',
      error: (error) => {
        console.error('Error in add new buyer:', error);
        return error.response?.data?.message || 'Failed to add Buyer';
      },
    });

    return promise;
  };
};

export const getBuyerById = (buyerId) => {
  return async (dispatch) => {
    const promise = api
      .get(`/nrcb/ecom/get/onebuyer/${buyerId}`, { requiresAuth: true })
      .then((response) => {
        dispatch(setSelectedBuyer(response));
        return response;
      });
    return promise.catch(() => {
      return { status: 'error', message: 'Failed to fetch buyer' };
    });
  };
};


export const contactUsMail = (data) => {
  return async (dispatch) => {
    const promise = axios.post(
      `${BASE_URL}/nrcb/ecom/email/contact`,
      data,  
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    );

    toast.promise(promise, {
      loading: "Mail Sending...",
      success: "We Received Your Message. We will get back to you shortly!",
      error: (error) => error.response?.data?.message || "Failed to contact us",
    });

    return promise;
  };
};
